import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useMaintenanceMode = () => {
  const [maintenance, setMaintenance] = useState<boolean | null>(null);

  useEffect(() => {
    let mounted = true;

    supabase
      .from("site_settings")
      .select("maintenance_mode")
      .eq("id", true)
      .maybeSingle()
      .then(({ data }) => {
        if (mounted) setMaintenance(!!data?.maintenance_mode);
      });

    const channel = supabase.channel(`site_settings_changes_${Math.random().toString(36).slice(2)}`);
    channel
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "site_settings" },
        (payload) => {
          const next = (payload.new as { maintenance_mode?: boolean })?.maintenance_mode;
          if (typeof next === "boolean") setMaintenance(next);
        },
      )
      .subscribe();

    return () => {
      mounted = false;
      supabase.removeChannel(channel);
    };
  }, []);

  const setMaintenanceMode = async (value: boolean) => {
    const { error } = await supabase
      .from("site_settings")
      .update({ maintenance_mode: value })
      .eq("id", true);
    if (!error) setMaintenance(value);
    return error;
  };

  return { maintenance, setMaintenanceMode };
};
